import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { AppContext } from '../../App';
import useGlynt from './useGlynt';

/**
 * Hook to set org context from URL params when navigating directly to /organization/:orgId
 */
export default function useSetOrgFromParams() {
  const { orgId: urlOrgId } = useParams<{ orgId: string }>();
  const { org, orgId, setOrg, setOrgId, setOrgLabel } = React.useContext(AppContext);

  const glynt = useGlynt();

  const { data: orgData, isLoading, isError } = useQuery({
    queryKey: ['org', urlOrgId],
    queryFn: async () => (await glynt).org.retrieve(urlOrgId!),
    enabled: !!urlOrgId && (!org || orgId !== urlOrgId),
    refetchOnWindowFocus: false,
  });

  React.useEffect(() => {
    if (orgData && urlOrgId) {
      if (orgId !== urlOrgId) {
        setOrgId(urlOrgId);
      }
      if (!org || org.id !== orgData.id) {
        setOrg(orgData);
        setOrgLabel(orgData.label);
      }
    }
  }, [orgData, urlOrgId, org, orgId, setOrg, setOrgId, setOrgLabel]);

  return { loading: isLoading, error: isError };
}
